/* 🤖 this file was generated by svg-to-ts */

import { SbIcons } from './lib/sb-icons.model';

export type SbIconsNameSubset<
  T extends Readonly<SbIcons[]>
> = T[number]['name'];

export * from './lib/sbIcons-apps.icon';
export * from './lib/sbIcons-arrow-down.icon';
export * from './lib/sbIcons-arrow-left.icon';
export * from './lib/sbIcons-arrow-right.icon';
export * from './lib/sbIcons-arrow-up.icon';
export * from './lib/sbIcons-baby-carriage.icon';
export * from './lib/sbIcons-balance-scale.icon';
export * from './lib/sbIcons-ban.icon';
export * from './lib/sbIcons-band-aid.icon';
export * from './lib/sbIcons-bars.icon';
export * from './lib/sbIcons-bell.icon';
export * from './lib/sbIcons-bolt.icon';
export * from './lib/sbIcons-book.icon';
export * from './lib/sbIcons-building.icon';
export * from './lib/sbIcons-calculator.icon';
export * from './lib/sbIcons-calendar-check.icon';
export * from './lib/sbIcons-calendar-day.icon';
export * from './lib/sbIcons-calendar-group.icon';
export * from './lib/sbIcons-calendar-month.icon';
export * from './lib/sbIcons-calendar-slash.icon';
export * from './lib/sbIcons-calendar-times.icon';
export * from './lib/sbIcons-calendar-week.icon';
export * from './lib/sbIcons-calendar.icon';
export * from './lib/sbIcons-camera.icon';
export * from './lib/sbIcons-car-sideview.icon';
export * from './lib/sbIcons-celebrate.icon';
export * from './lib/sbIcons-chart-line.icon';
export * from './lib/sbIcons-check-circle-solid.icon';
export * from './lib/sbIcons-check-circle.icon';
export * from './lib/sbIcons-check.icon';
export * from './lib/sbIcons-chevron-down.icon';
export * from './lib/sbIcons-chevron-left.icon';
export * from './lib/sbIcons-chevron-right.icon';
export * from './lib/sbIcons-chevron-up.icon';
export * from './lib/sbIcons-circle.icon';
export * from './lib/sbIcons-clipboard.icon';
export * from './lib/sbIcons-clock.icon';
export * from './lib/sbIcons-coffee.icon';
export * from './lib/sbIcons-comment.icon';
export * from './lib/sbIcons-copy.icon';
export * from './lib/sbIcons-credit-card.icon';
export * from './lib/sbIcons-download.icon';
export * from './lib/sbIcons-draggabledots.icon';
export * from './lib/sbIcons-ellipsis-h.icon';
export * from './lib/sbIcons-ellipsis-v.icon';
export * from './lib/sbIcons-email.icon';
export * from './lib/sbIcons-euro-circle.icon';
export * from './lib/sbIcons-exchange-horizontal.icon';
export * from './lib/sbIcons-exchange-vertical.icon';
export * from './lib/sbIcons-exclamation-circle-solid.icon';
export * from './lib/sbIcons-exclamation-circle.icon';
export * from './lib/sbIcons-exclamation-triangle.icon';
export * from './lib/sbIcons-external-link.icon';
export * from './lib/sbIcons-eye-slash.icon';
export * from './lib/sbIcons-eye.icon';
export * from './lib/sbIcons-file.icon';
export * from './lib/sbIcons-filter.icon';
export * from './lib/sbIcons-flag.icon';
export * from './lib/sbIcons-future.icon';
export * from './lib/sbIcons-history.icon';
export * from './lib/sbIcons-hospital.icon';
export * from './lib/sbIcons-house.icon';
export * from './lib/sbIcons-info-circle.icon';
export * from './lib/sbIcons-kid.icon';
export * from './lib/sbIcons-layer-group.icon';
export * from './lib/sbIcons-lifebuoy.icon';
export * from './lib/sbIcons-lock-open.icon';
export * from './lib/sbIcons-lock.icon';
export * from './lib/sbIcons-map-marker-slash.icon';
export * from './lib/sbIcons-map-marker.icon';
export * from './lib/sbIcons-medkit.icon';
export * from './lib/sbIcons-megaphone.icon';
export * from './lib/sbIcons-minus.icon';
export * from './lib/sbIcons-money-insert.icon';
export * from './lib/sbIcons-money-withdraw.icon';
export * from './lib/sbIcons-notepad.icon';
export * from './lib/sbIcons-paper-plane.icon';
export * from './lib/sbIcons-paperclip.icon';
export * from './lib/sbIcons-pen.icon';
export * from './lib/sbIcons-percentage-square.icon';
export * from './lib/sbIcons-percentage.icon';
export * from './lib/sbIcons-phone.icon';
export * from './lib/sbIcons-plane-departure.icon';
export * from './lib/sbIcons-plane.icon';
export * from './lib/sbIcons-plus-minus.icon';
export * from './lib/sbIcons-plus.icon';
export * from './lib/sbIcons-puzzle-piece.icon';
export * from './lib/sbIcons-question-circle.icon';
export * from './lib/sbIcons-question.icon';
export * from './lib/sbIcons-redo.icon';
export * from './lib/sbIcons-refresh.icon';
export * from './lib/sbIcons-repeat.icon';
export * from './lib/sbIcons-search.icon';
export * from './lib/sbIcons-setting.icon';
export * from './lib/sbIcons-shield-exclamation.icon';
export * from './lib/sbIcons-sign-alt.icon';
export * from './lib/sbIcons-sliders-v.icon';
export * from './lib/sbIcons-sort.icon';
export * from './lib/sbIcons-star.icon';
export * from './lib/sbIcons-stars.icon';
export * from './lib/sbIcons-stopwatch.icon';
export * from './lib/sbIcons-structure.icon';
export * from './lib/sbIcons-suitcase.icon';
export * from './lib/sbIcons-tachometer.icon';
export * from './lib/sbIcons-target.icon';
export * from './lib/sbIcons-times-circle.icon';
export * from './lib/sbIcons-times.icon';
export * from './lib/sbIcons-toggle.icon';
export * from './lib/sbIcons-trash.icon';
export * from './lib/sbIcons-upload.icon';
export * from './lib/sbIcons-user-check.icon';
export * from './lib/sbIcons-user-times.icon';
export * from './lib/sbIcons-user.icon';
export * from './lib/sbIcons-users.icon';
export * from './lib/sbIcons-utensils.icon';
export * from './lib/sbIcons-windsock.icon';
export * from './lib/complete-icon-set';
export * from './lib/sb-icons.model';
